
import { Breadcrumbs, IconButton, Typography, Button } from "@mui/material";

import DefaultTemplate from "@/templates/DefaultTemplate/DefaultTemplate";
import { PageHeader } from "@adl/smart-ui-library";
import { useAppDispatch } from "@/hooks";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import { setSelectedTasks } from "@/redux/tasksSlice";
import { setSelectedCase, setSelectedDocument } from "@/redux/casesSlice";
import { useMsal } from "@azure/msal-react";
import Notifications from "@/components/Notifications";

import VaultIcon from "@/components/VaultIcon";
import VaultTextLogo from "@/components/VaultTextLogo";
import { useNavigate } from "react-router-dom";
import * as Styled from "./MyTasksWrapper.styles";

import "filepond/dist/filepond.min.css";

import FileMetaModal from "./FileMetaModal";

const NonPCodeForm = () => {
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  const navigateToHome = () => {
    appDispatch(setSelectedTasks(false));
    appDispatch(setSelectedCase(null));
    appDispatch(setSelectedDocument(null));
    navigate(`/`);
  };
  const { instance } = useMsal();

  const onLogout = () => {
    instance.logout();
  };

  const onTaskBtnClick = () => {
    appDispatch(setSelectedTasks([]));
    navigate(`/tasks`);
  };
  const onNonBtnClick = () => {
    appDispatch(setSelectedTasks([]));
    navigate(`/non-p-code`);
  };

  const accessLevelName = sessionStorage.getItem('accessLevelName') || '';


  return (
    <DefaultTemplate paddingTop={200}>
      <>
        <PageHeader
          logo={
            <VaultIcon width={40} height={40} handleClick={navigateToHome} />
          }
          navigation={
            <>
              <Notifications />
              {accessLevelName !== 'NoAccess' &&
                <Button data-testid="tasks-button" onClick={onNonBtnClick}>
                  Non-P-Code Documents
                </Button>
              }
              <Button onClick={onTaskBtnClick}>Tasks</Button>
              <Button onClick={onLogout}>Logout</Button>
            </>
          }
          subHeader={
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<NavigateNextIcon fontSize="small" />}
            >
              <IconButton onClick={navigateToHome}>
                <HomeOutlinedIcon />
              </IconButton>
              <Typography color="text.primary">Non-P-Code Documents</Typography>
              <Typography color="text.primary">{window.location.href.indexOf("edit") > -1 ? `Edit Document` : `New Document`}</Typography>
            </Breadcrumbs>
          }
        >
          <VaultTextLogo />
        </PageHeader>

        <Styled.MyTasksWrapper>

          <Styled.MyTasksWrapperLeft id="document-profile-left">
            <div style={{ display: 'flex', width: '100%' }}>

            </div>
            <FileMetaModal

              data={''}

            />


          </Styled.MyTasksWrapperLeft>
        </Styled.MyTasksWrapper>.

      </>

    </DefaultTemplate>
  );
};

export default NonPCodeForm;
